import { Link } from "wouter";
import { Twitter, Linkedin, Facebook, Instagram } from "lucide-react";
import { ContactButton } from "./ContactButton";
import { useSectionNav } from "./useSectionNav";

const socials = [
  { Icon: Twitter, label: "Twitter" },
  { Icon: Linkedin, label: "LinkedIn" },
  { Icon: Facebook, label: "Facebook" },
  { Icon: Instagram, label: "Instagram" },
];

export function LandingFooter() {
  const goToSection = useSectionNav();

  return (
    <footer className="border-t border-slate-200 bg-slate-50">
      <div className="mx-auto max-w-7xl px-5 py-14 sm:px-8">
        <div className="grid gap-10 sm:grid-cols-2 md:grid-cols-[1.5fr_1fr_1fr_1fr]">
          <div>
            <img
              src="/logo.png"
              alt="PalNote logo — AI clinical documentation assistant"
              width="36"
              height="36"
              loading="lazy"
              className="h-9 w-auto"
            />
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-slate-500">
              Clinical documentation, powered by conversation.
            </p>
            <div className="mt-6 flex gap-3">
              {socials.map(({ Icon, label }) => (
                <a
                  key={label}
                  href="#"
                  aria-label={label}
                  className="flex h-9 w-9 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-500 transition-colors hover:border-blue-200 hover:text-blue-600"
                >
                  <Icon className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-slate-900">Product</h3>
            <ul className="mt-4 space-y-3 text-sm text-slate-500">
              <li>
                <button onClick={() => goToSection("features")} className="hover:text-slate-900">
                  Features
                </button>
              </li>
              <li>
                <button onClick={() => goToSection("pricing")} className="hover:text-slate-900">
                  Pricing
                </button>
              </li>
              <li>
                <button onClick={() => goToSection("how-it-works")} className="hover:text-slate-900">
                  How It Works
                </button>
              </li>
              <li>
                <Link href="/faq" className="hover:text-slate-900">
                  FAQ
                </Link>
              </li>
              <li>
                <Link href="/sign-up" className="hover:text-slate-900">
                  Get Started
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-slate-900">Solutions</h3>
            <ul className="mt-4 space-y-3 text-sm text-slate-500">
              <li>
                <Link href="/chiropractor-ai-scribe" className="hover:text-slate-900">
                  For Chiropractors
                </Link>
              </li>
              <li>
                <Link href="/physiotherapy-ai-scribe" className="hover:text-slate-900">
                  For Physiotherapists
                </Link>
              </li>
              <li>
                <Link href="/massage-therapy-ai-scribe" className="hover:text-slate-900">
                  For Massage Therapists
                </Link>
              </li>
              <li>
                <Link href="/rehabilitation-clinic-ai-scribe" className="hover:text-slate-900">
                  For Rehab Clinics
                </Link>
              </li>
              <li>
                <Link href="/occupational-therapy-ai-scribe" className="hover:text-slate-900">
                  For Occupational Therapists
                </Link>
              </li>
              <li>
                <Link href="/sports-medicine-ai-scribe" className="hover:text-slate-900">
                  For Sports Medicine
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-slate-900">Company</h3>
            <ul className="mt-4 space-y-3 text-sm text-slate-500">
              <li>
                <Link href="/privacy" className="hover:text-slate-900">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link href="/terms" className="hover:text-slate-900">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link href="/trust" className="hover:text-slate-900">
                  Trust Center
                </Link>
              </li>
              <li>
                <Link href="/data-security" className="hover:text-slate-900">
                  Data Processing & Security
                </Link>
              </li>
              <li>
                <ContactButton className="hover:text-slate-900">Contact</ContactButton>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-slate-200 pt-6 text-xs text-slate-400 sm:flex-row">
          <span>© {new Date().getFullYear()} PalNote. All rights reserved.</span>
          <span>Clinical documentation, powered by conversation.</span>
        </div>
      </div>
    </footer>
  );
}
